import React from "react";
import { Calendar, Clock, X, User, CreditCard } from "lucide-react";
import { formatVND } from '../../../../../utils/format';
// Đảm bảo đường dẫn import đúng
import getBankInfo from '../../../../../services/service'; 

const TransactionByDayModal = ({
  open,
  onClose,
  selectedDateData,
  transactions,
}) => {
  if (!open || !selectedDateData) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6">
      {/* Overlay */}
      <div
        className="absolute inset-0 bg-slate-900/40 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="bg-white rounded-3xl shadow-2xl w-full max-w-3xl relative z-10 flex flex-col max-h-[85vh] animate-in zoom-in-95 duration-200">
        {/* Header */}
        <div className="px-6 py-5 border-b border-slate-100 flex items-center justify-between bg-slate-50/50 rounded-t-3xl">
          <div>
            <h3 className="text-lg font-black text-slate-800">
              Chi tiết giao dịch
            </h3>
            <div className="flex items-center gap-2 mt-1">
              <Calendar size={14} className="text-indigo-500" />
              <span className="text-sm font-bold text-slate-500">
                Ngày {selectedDateData?.date}
              </span>
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-2 bg-white rounded-full text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-all shadow-sm border border-slate-200"
          >
            <X size={20} />
          </button>
        </div>

        {/* Summary */}
        <div className="px-6 py-4 grid grid-cols-2 gap-4">
          <div className="p-3 bg-emerald-50 border border-emerald-100 rounded-xl">
            <p className="text-[10px] font-bold text-emerald-600 uppercase tracking-wider mb-1">
              Tổng doanh thu ngày
            </p>
            <p className="text-lg font-black text-slate-800">
              {formatVND(selectedDateData?.revenue)}
            </p>
          </div>

          <div className="p-3 bg-indigo-50 border border-indigo-100 rounded-xl">
            <p className="text-[10px] font-bold text-indigo-600 uppercase tracking-wider mb-1">
              Tổng số giao dịch
            </p>
            <p className="text-lg font-black text-slate-800">
              {selectedDateData?.tx_count} GD
            </p>
          </div>
        </div>

        {/* Transaction List */}
        <div className="flex-1 overflow-y-auto px-6 pb-6">
          <table className="w-full text-left border-collapse">
            <thead className="sticky top-0 bg-white z-10">
              <tr className="text-[10px] font-black text-slate-400 uppercase tracking-wider border-b border-slate-100">
                <th className="py-3 pr-4">Mã GD</th>
                <th className="py-3 px-2">Thời gian</th>
                <th className="py-3 px-2">Người giao dịch</th>
                <th className="py-3 pl-4 text-center">Số tiền</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-50">
              {transactions.length > 0 &&
                transactions.map((tx) => {
                  const bankInfo = getBankInfo(tx.bank_code);
                  // Xác định tên hiển thị
                  const displayName = tx.customer_name || "Khách vãng lai";

                  return (
                    <tr
                      key={tx.id || tx.transaction_id}
                      className="group hover:bg-slate-50 transition-colors"
                    >
                      {/* Mã GD */}
                      <td className="py-3 pr-4 align-middle">
                        <span className="text-xs font-mono font-bold text-slate-500 group-hover:text-indigo-600 transition-colors block mt-1">
                          {tx.transaction_id}
                        </span>
                      </td>

                      {/* Thời gian */}
                      <td className="py-3 px-2 align-middle">
                        <div className="flex items-center gap-1.5 text-xs font-medium text-slate-600 mt-1">
                          <Clock size={12} className="text-slate-300" />
                          {new Date(tx.tx_time).toLocaleTimeString("vi-VN", {
                            hour12: false,
                            hour: "2-digit",
                            minute: "2-digit"
                          })}
                        </div>
                      </td>

                      {/* --- NGƯỜI GIAO DỊCH (Đã sửa format) --- */}
                      <td className="py-3 px-2 align-middle">
                        <div className="flex flex-col gap-1.5">
                          {/* Dòng 1: Tên (Số tài khoản) */}
                          <div className="text-xs font-bold text-slate-800 ">
                             {displayName}
                             {tx.customer_account && (
                               <span className="text-slate-500 font-normal font-mono ml-2">
                                 ({tx.customer_account})
                               </span>
                             )}
                          </div>

                          {/* Dòng 2: Badge Ngân hàng */}
                          <div className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-md border text-[10px] font-bold w-fit ${bankInfo.bg} ${bankInfo.color} border-transparent bg-opacity-50`}>
                            {bankInfo.logo ? (
                                <img 
                                    src={bankInfo.logo} 
                                    alt={bankInfo.name} 
                                    className="h-6 object-contain" 
                                    onError={(e) => e.target.style.display = 'none'}
                                />
                            ) : (
                                <CreditCard size={10} />
                            )}
                            {bankInfo.name}
                          </div>
                        </div>
                      </td>

                      {/* Số tiền */}
                      <td className="py-3 pl-4 text-right align-middle">
                        <span className="text-sm font-bold text-slate-800 block mr-2">
                          {formatVND(tx.amount * 1000)}
                        </span>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>

          {transactions.length === 0 && (
             <div className="text-center py-10">
                 <p className="text-slate-400 text-sm">Không có giao dịch nào trong ngày này.</p>
             </div>
          )}

          <div className="mt-6 text-center">
            <p className="text-[10px] text-slate-300 font-medium italic">
              Hiển thị {transactions.length} giao dịch
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionByDayModal;